import BaseController from './base_controller'

export default class extends BaseController {
  static values = { imo: String }

  connect() {
    this.boundRecord = event => this.record(event)
    window.addEventListener('calculation:outcome', this.boundRecord)
  }

  disconnect() {
    window.removeEventListener('calculation:outcome', this.boundRecord)
  }

  record({ detail }) {
    if (String(detail.imo) !== this.imoValue) return

    this.element.dataset.calculationOutcome = detail.hasError ? 'error' : 'ok'
    this.dispatch('recorded', { detail: { ok: !detail.hasError } })
  }
}
